<template>
  <tr>
    <td colspan="2">
      <table>
        <tr>
          <td>
            <font style="font-weight: bold; font-size: 16px; color:#000000;">
              SkyParkSecure Customer Service
            </font>
          </td>
        </tr>
        <tr>
          <td height="5" style="line-height:5px; font-size:0px;">&nbsp;</td>
        </tr>
        <tr>
          <td height="5" style="line-height:5px; font-size:0px;">&nbsp;</td>
        </tr>
        <tr>
          <td>
            <font style="font-weight: normal; font-size: 14px; color:#000000;">
              Email us at <a href="mailto:info@skyparksecure.com">info@skyparksecure.com</a>
            </font>
          </td>
        </tr>
        <tr>
          <td>
            <font style="font-weight: normal; font-size: 14px; color:#000000;">
              Office hours: Monday - Friday (9am - 5pm)
            </font>
          </td>
        </tr>
      </table>
    </td>
  </tr>
</template>

<script>
export default {
  name: "confirmation-view-customer"
};
</script>